// EP-135 Tier 1 — Governance i18n (TH). Parallel structure to en/governance.ts.
export default {
  nav: {
    meetings: 'การประชุม',
    committee: 'คณะกรรมการ',
  },

  meetings: {
    title: 'การประชุม',
    description: 'การประชุมใหญ่ การประชุมวิสามัญ และการประชุมคณะกรรมการ — บันทึกการบริหารนิติบุคคล',

    labels: {
      title: 'หัวข้อ',
      meeting_type: 'ประเภท',
      status: 'สถานะ',
      meeting_at: 'วันที่ประชุม',
      venue: 'สถานที่',
      agenda: 'ระเบียบวาระ',
      call_number: 'การประชุมครั้งที่',
      notice_lead_days: 'จำนวนวันแจ้งล่วงหน้า',
      meeting_url: 'ลิงก์ประชุมออนไลน์',
      meeting_access_note: 'หมายเหตุการเข้าถึง',
      minutes_body: 'รายงานการประชุม',
      quorum_basis: 'ฐานขององค์ประชุม',
      property: 'อาคาร',
      certified_at: 'ลงนามเมื่อ',
    },

    types: {
      annual_general_meeting: 'ประชุมใหญ่สามัญประจำปี',
      extraordinary: 'ประชุมใหญ่วิสามัญ',
      committee: 'ประชุมคณะกรรมการ',
    },

    statuses: {
      draft: 'ร่าง',
      noticed: 'แจ้งล่วงหน้าแล้ว',
      in_progress: 'กำลังดำเนินการ',
      voting_closed: 'ปิดลงคะแนนแล้ว',
      closed: 'ปิดการประชุม',
      certified: 'ลงนามรับรองแล้ว',
    },

    actions: {
      new_meeting: 'สร้างการประชุมใหม่',
      add_resolution: 'เพิ่มมติ',
      new_notice: 'ส่งหนังสือแจ้งใหม่',
      send_for_certification: 'ส่งลงนามรับรอง',
      close_voting: 'ปิดลงคะแนน',
      carry_over: 'เลื่อนไปประชุมครั้งที่ 2',
      view_audit_log: 'ดูบันทึกตรวจสอบ',
      snapshot_attendees: 'แชะบัญชีรายชื่อ',
      add_attendee: 'เพิ่มผู้เข้าร่วม',
      record_vote: 'บันทึกคะแนน',
      back_to_meetings: 'กลับไปรายการประชุม',
    },

    empty: {
      loading: 'กำลังโหลดรายงานการประชุม…',
      no_meetings: 'ยังไม่มีการประชุม',
      no_meetings_description:
        'สร้างการประชุมใหญ่ วิสามัญ หรือคณะกรรมการครั้งแรกเพื่อเริ่มบันทึกการบริหาร',
      no_resolutions: 'ยังไม่มีมติ',
      no_resolutions_description:
        'เพิ่มมติเมื่อระเบียบวาระต้องการการตัดสินใจที่บันทึกไว้',
      no_notices: 'ยังไม่ได้ส่งหนังสือแจ้ง',
      no_notices_description:
        'ส่งหนังสือแจ้งเพื่อบันทึกหลักฐานการแจ้งเจ้าของร่วมหรือกรรมการทุกคน',
      no_deliveries: 'ไม่มีรายการจัดส่งสำหรับหนังสือแจ้งนี้',
      could_not_load_notice: 'ไม่สามารถโหลดรายละเอียดหนังสือแจ้งได้',
    },

    messages: {
      created: 'สร้างการประชุมแล้ว',
      updated: 'อัปเดตการประชุมแล้ว',
      sent_for_certification: 'ส่งการประชุมเพื่อลงนามรับรองแล้ว',
      voting_closed: 'ปิดลงคะแนนแล้ว — บันทึกผลคะแนนถูกตรึงไว้ในมติทุกข้อ',
      carried_over: 'สร้างการประชุมครั้งที่ 2 แล้ว',
      attendees_snapshot: 'แชะบัญชีรายชื่อจากสัญญาเจ้าของที่ยังมีผล',
      attendee_added: 'เพิ่มผู้เข้าร่วมแล้ว',
      vote_recorded: 'บันทึกคะแนนแล้ว',
      resolution_added: 'เพิ่มมติแล้ว',
      resolution_updated: 'อัปเดตมติแล้ว',
      notice_created: 'ส่งหนังสือแจ้งแล้ว',
      not_ready_for_certification: 'ต้องปิดการประชุมก่อนส่งลงนามรับรอง',
      not_in_progress_voting: 'ต้องอยู่ในสถานะ "กำลังดำเนินการ" จึงจะปิดลงคะแนนได้',
      not_call_one_carry_over: 'เฉพาะการประชุมครั้งที่ 1 เท่านั้นที่เลื่อนไปครั้งที่ 2 ได้',
      carry_over_date_required: 'ต้องระบุวันเวลาของการประชุมครั้งที่ 2',
    },

    filters: {
      all_types: 'ทุกประเภท',
      all_statuses: 'ทุกสถานะ',
      by_date: 'ล่าสุดก่อน',
    },
  },

  resolutions: {
    title: 'มติ',
    labels: {
      seq: 'ลำดับ',
      title: 'หัวข้อ',
      body: 'เนื้อหา',
      note: 'หมายเหตุ',
      decided_by: 'วิธีตัดสิน',
      status: 'ผลลัพธ์',
      threshold_rule: 'เกณฑ์',
      threshold_basis: 'ฐาน',
      secret: 'ลงคะแนนลับ',
      from_agenda: 'จากระเ�ียบวาระ',
    },

    decided_by: {
      vote: 'โหวต',
      consensus: 'ฉันทามติ',
      chair_ruling: 'ดุลยพินิจประธาน',
      noted: 'รับทราบ',
    },

    statuses: {
      proposed: 'เสนอ',
      carried: 'ผ่าน',
      defeated: 'ไม่ผ่าน',
      withdrawn: 'ถอน',
      deferred: 'เลื่อน',
    },

    threshold_basis: {
      of_attendees: 'ของผู้เข้าร่วม',
      of_all_owners: 'ของเจ้าของทั้งหมด',
    },

    messages: {
      certified_immutable: 'มติที่ลงนามรับรองแล้วแก้ไขไม่ได้ ให้ออกมติติดตามแทน',
      not_deletable: 'มติคือบันทึกของกระบวนการทางกฎหมาย แก้ไข ไม่ลบ',
    },
  },

  committee: {
    title: 'คณะกรรมการ',
    description: 'คณะกรรมการปัจจุบันและที่ผ่านมาซึ่งได้รับเลือกจากที่ประชุมใหญ่',

    labels: {
      customer: 'กรรมการ',
      role: 'ตำแหน่ง',
      elected_on: 'วันที่ได้รับเลือก',
      term_starts_on: 'วันที่เริ่มวาระ',
      term_ends_on: 'วันที่สิ้นสุดวาระ',
      ended_on: 'สิ้นสุดวาระเมื่อ',
      ended_reason: 'เหตุผลที่สิ้นสุด',
      not_qualifying: 'ไม่มีคุณสมบัติแล้ว',
      qualifies: 'มีคุณสมบัติ',
    },

    roles: {
      chair: 'ประธาน',
      vice: 'รองประธาน',
      secretary: 'เลขานุการ',
      treasurer: 'เหรัญญิก',
      member: 'กรรมการ',
    },

    actions: {
      new_member: 'เพิ่มกรรมการใหม่',
      end_term: 'สิ้นสุดวาระ',
    },

    empty: {
      no_members: 'ยังไม่มีกรรมการ',
      no_members_description: 'เพิ่มกรรมการที่ได้รับเลือกจากการประชุมใหญ่ล่าสุด',
    },

    messages: {
      created: 'เพิ่มกรรมการแล้ว',
      updated: 'อัปเดตกรรมการแล้ว',
      term_ended: 'สิ้นสุดวาระแล้ว',
      not_a_shared_owner: 'กรรมการต้องถือกรรมสิทธิ์ร่วม (OwnerContract) ที่ยังมีผลในบัญชีนี้',
      end_term_title: 'สิ้นสุดวาระ',
      end_term_confirm: 'สิ้นสุดวาระของ {{name}} หรือไม่? �ารกระทำนี้ไม่สามารถยกเลิกได้',
      reason_required: 'ต้องระบุเหตุผลในการสิ้นสุดวาระ',
      end_reason_label: 'เหตุผล (เช่น "มติที่ประชุมใหญ่ 2571 ข้อ 3")',
      end_date_label: 'วันที่สิ้นสุด',
    },

    filters: {
      all_roles: 'ทุกตำแหน่ง',
      active: 'ปัจจุบัน',
      ended: 'สิ้นสุดแล้ว',
      show_active: 'เฉพาะที่ยังดำรงตำแหน่ง',
    },
  },

  // EP-135 Tier 2 — หนังสือแจ้ง (พิสูจน์การจัดส่ง). การส่งหนังสือแจ้ง
  // หนึ่งฉบับจะสร้างแถวการจัดส่งหนึ่งแถวต่อผู้รับ — ตัวแถวคือหลักฐาน
  // สถานะ delivered/failed/pending เป็นการติดตามที่ผู้ดูแลบันทึกเพิ่ม
  notices: {
    title: 'หนังสือแจ้ง',

    labels: {
      body: 'เนื้อหาหนังสือแจ้ง',
      channel: 'ช่องทาง',
      recipient: 'ผู้รับ',
      status: 'สถานะ',
      detail: 'รายละเอียด',
    },

    channels: {
      liff: 'LIFF (ในแอป)',
      line: 'LINE',
      email: 'อีเมล',
      post: 'ไปรษณีย์',
    },

    delivery: {
      delivered: 'จัดส่งสำเร็จ',
      failed: 'จัดส่งไม่สำเร็จ',
      pending: 'รอติดตาม',
    },

    counts: {
      audience_one: '{{count}} ผู้รับ',
      audience_other: '{{count}} ผู้รับ',
      delivered_one: 'จัดส่งสำเร็จ {{count}}',
      delivered_other: 'จัดส่งสำเร็จ {{count}}',
      failed_one: 'ล้มเหลว {{count}}',
      failed_other: 'ล้มเหลว {{count}}',
      pending_one: 'รอติดตาม {{count}}',
      pending_other: 'รอติดตาม {{count}}',
    },

    actions: {
      mark_delivered: 'บันทึกจัดส่งสำเร็จ',
      mark_failed: 'บันทึกล้มเหลว',
      clear: 'รีเซ็ต',
    },

    help: {
      materialise:
        'การบันทึกจะสร้างแถวการจัดส่งหนึ่งแถวต่อผู้รับ — ทุก OwnerContract ที่ยังมีผลสำหรับ AGM/EGM หรือทุกกรรมการที่ยังดำรงตำแหน่งสำหรับการประชุมคณะกรรมการ',
      failed_reason_prompt: 'เหตุผลที่จัดส่งไม่สำเร็จ (เช่น "LINE 400", "อีเมลตีกลับ", "ไปรษณีย์ตีกลับ"):',
    },

    messages: {
      delivery_state_conflict:
        'ไม่สามารถระบุว่าจัดส่งสำเร็จและล้มเหลวพร้อมกันได้ กรุณาเลือกอย่างใดอย่างหนึ่ง',
    },
  },

  errors: {
    condominium_required:
      'หน้านี้ใช้ได้เมื่อเปิดใช้งานโมดูล Condominium ในการตั้งค่าบัญชี',
  },

  // EP-135 Tier 3 — ผู้เข้าร่วม (แชะบัญชีรายชื่อตามสัญญาเจ้าของ)
  attendees: {
    title: 'ผู้เข้าร่วม',
    description: 'แชะบัญชีรายชื่อเจ้าของร่วมตามสัญญาเจ้าของ ณ วันส่งหนังสือแจ้ง',

    labels: {
      customer: 'เจ้าของร่วม',
      presence: 'การเข้าร่วม',
      weight: 'น้ำหนักคะแนน',
      units: 'ห้อง',
      proxy_holder: 'ผู้รับมอบฉันทะ',
      proxy_document: 'เอกสารมอบฉันทะ',
      checked_in_at: 'เช็คอินเมื่อ',
    },

    presences: {
      absent: 'ไม่มา',
      remote: 'ออนไลน์',
      in_person: 'มาด้วยตนเอง',
      proxy: 'มอบฉันทะ',
    },

    actions: {
      snapshot: 'แชะบัญชีรายชื่อ',
      add: 'เพิ่มผู้เข้าร่วม',
      mark_absent: 'ไม่มา',
      mark_remote: 'ออนไลน์',
      mark_in_person: 'มาด้วยตนเอง',
      mark_proxy: 'มอบฉันทะ',
    },

    messages: {
      snapshot_done_one: 'แชะ {{count}} รายชื่อจากบัญชีเจ้าของที่ยังมีผล',
      snapshot_done_other: 'แชะ {{count}} รายชื่อจากบัญชีเจ้าของที่ยังมีผล',
      snapshot_existing: 'แชะไปแล้ว — ไม่มีรายชื่อใหม่ถูกสร้าง',
    },

    empty: {
      no_attendees: 'ยังไม่มีผู้เข้าร่วม',
      no_attendees_description:
        'แชะบัญชีรายชื่อเพื่อตรึงน้ำหนักคะแนน ณ วันส่งหนังสือแจ้ง แล้วเช็คอินเมื่อผู้เข้าร่วมมาถึง',
    },
  },

  // EP-135 Tier 3 — การลงคะแนน + บันทึกตรวจสอบ ETDA
  votes: {
    title: 'การลงคะแนน',
    ballot_title: 'บัตรลงคะแนน',

    labels: {
      attendee: 'ผู้เข้าร่วม',
      choice: 'ตัวเลือก',
      weight: 'น้ำหนัก',
      cast_at: 'ลงเมื่อ',
      cast_via: 'วิธี',
      surface: 'ช่องทาง',
      identity_level: 'ยืนยันตัวตน',
      receipt_hash: 'แฮชใบเสร็จ',
      recorded_by: 'ผู้บันทึก',
      filter_choice: 'กรองตามตัวเลือก',
    },

    choices: {
      for: 'เห็นชอบ',
      against: 'ไม่เห็นชอบ',
      abstain: 'งดออกเสียง',
    },

    cast_via: {
      self: 'ด้วยตนเอง (แอป)',
      recorded: 'ผู้ดำเนินการบันทึก',
    },

    surfaces: {
      liff: 'LIFF',
      web_admin: 'เว็บแอดมิน',
    },

    identity_levels: {
      dipchip: 'Dipchip',
      passport: 'หนังสือเดินทาง',
      none: 'ยังไม่ยืนยัน',
    },

    actions: {
      record_vote: 'บันทึกคะแนน',
      choose_attendee: 'เลือกผู้เข้าร่วม',
    },

    tally: {
      title: 'ผลคะแนน',
      for: 'เห็นชอบ',
      against: 'ไม่เห็นชอบ',
      abstain: 'งดออกเสียง',
      tied: 'เสมอกัน',
      decision: 'ผลการลงมติ',
      total_cast: 'คะแนนรวม',
      total_attendees: 'ผู้ลงคะแนน',
      denominator: 'ฐาน',
      threshold: 'เกณฑ์',
      decision_passed: 'ผ่าน',
      decision_defeated: 'ไม่ผ่าน',
      snapshot_at: 'ตรึงเมื่อ',
      no_snapshot: 'ยังไม่ได้ปิดลงคะแนน — ผลคะแนนจะถูกตรึงเมื่อปิด',
      electronic_voting_disabled:
        'ข้อบังคับของบัญชีนี้ไม่อนุญาตให้ลงคะแนนทางอิเล็กทรอนิกส์',
    },

    audit_log: {
      download: 'ดาวน์โหลด JSON',
      title: 'บันทึกตรวจสอบ (ETDA ขมธอ. 26-2564)',
      description:
        'บันทึกคะแนนแบบไม่เปลี่ยนแปลงที่ประธานและเลขานุการใช้เดินทบทวนก่อนลงนามรับรอง มติลับจะซ่อนตัวผู้ลงคะแนน',
      electronic_voting_permitted: 'อนุญาตให้ลงคะแนนทางอิเล็กทรอนิกส์',
      no_ballots: 'ยังไม่มีบัตรลงคะแนน',
    },

    messages: {
      secret_no_identity:
        'มตินี้เป็นการลงคะแนนลับ — ระบบจะซ่อนตัวผู้ลงคะแนน (§4a)',
    },

    empty: {
      no_votes: 'ยังไม่มีบัตรลงคะแนน',
      no_votes_description:
        'บันทึกคะแนนจากฝั่งผู้ดำเนินการ หรือรอให้เจ้าของร่วมลงคะแนนในแอปลูกค้า',
    },
  },

  // EP-135 Tier 4 — การจัดทำรายงานการประชุม + ลงนามอิเล็กทรอนิกส์
  minutes: {
    title: 'รายงานการประชุม',
    description:
      'จัดทำจากข้อมูลการประชุม + สรุปผลคะแนนที่ถูกตรึงไว้ สถานะร่างจนกว่าประธานและเลขานุการจะลงนามทั้งคู่ (§8 Q-5)',
    draft_banner: 'ฉบับร่าง — ยังไม่ได้ลงนาม รอประธานและเลขานุการลงนามอิเล็กทรอนิกส์',
    certified_banner: 'ลงนามครบแล้ว — ประธานและเลขานุการลงนามเรียบร้อย',
    sections: {
      header: 'หัวกระดาษ',
      attendance: 'ผู้เข้าร่วม',
      resolutions: 'มติ',
      certification: 'การลงนาม',
    },
    actions: {
      view_pdf: 'ดูไฟล์ PDF รายงานการประชุม',
      sign_chair: 'ลงนามในฐานะประธาน',
      sign_secretary: 'ลงนามในฐานะเลขานุการ',
      reset_chair_signature: 'ยกเลิกลายเซ็นประธาน',
      reset_secretary_signature: 'ยกเลิกลายเซ็นเลขานุการ',
    },
    signing: {
      chair_signed_at: 'ประธานลงนามเมื่อ',
      secretary_signed_at: 'เลขานุการลงนามเมื่อ',
      pending_chair: 'รอประธานลงนามอิเล็กทรอนิกส์',
      pending_secretary: 'รอเลขานุการลงนามอิเล็กทรอนิกส์',
      both_signed: 'ลงนามครบทั้งสองฝ่าย — การประชุมได้รับการรับรอง',
      not_ready: 'ปิดการลงคะแนนก่อนจัดทำรายงานการประชุม',
      pdf_key_label: 'คีย์ไฟล์ PDF รายงานการประชุม',
    },
    errors: {
      already_certified: 'การประชุมนี้ได้รับการรับรองแล้ว ไม่สามารถลงนามซ้ำได้',
      not_ready: 'ต้องปิดการประชุมหรือปิดการลงคะแนนก่อนลงนาม',
      invalid_role: 'บทบาทต้องเป็นประธานหรือเลขานุการ',
      signer_not_found: 'ผู้ลงนามไม่ได้อยู่ในบัญชีนี้',
      reset_failed: 'ไม่สามารถยกเลิกลายเซ็นได้',
    },
    messages: {
      signed_chair: 'บันทึกลายเซ็นประธานแล้ว',
      signed_secretary: 'บันทึกลายเซ็นเลขานุการแล้ว — การประชุมได้รับการรับรอง',
      reset_chair: 'ยกเลิกลายเซ็นประธานแล้ว',
      reset_secretary: 'ยกเลิกลายเซ็นเลขานุการแล้ว',
    },
  },
}
